import React from 'react'
import useSettingsV2 from '../../hooks/useSettingsV2'
import Global from './Global'
import Header from './Header'
import LogsLast from './LogsLast'
import Users from './Users'

function StatsScreen() {
  const { settings } = useSettingsV2()

  return (
    <div style={{ padding: '0 10px', display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <Header />
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 400px' }}>
          <Global />
        </div>
      </div>
      {!settings?.FO_MEETING_STATS_LOGS_HIDE && <LogsLast />}
      {settings?.FO_MEETING_STATS_SETTINGS_ID && <Users />}
    </div>
  )
}

export default StatsScreen
